import { RouterChild } from '@/router';

export default [
  {
    name: 'conservatorship-manage-contact-persons',
    path: 'conservatorship/:conservatorship/contact/:contact/contact-persons',
    component: () => import('./views/ManageContactPersons.vue')
  } as RouterChild
];
